import { IValueViewModel, DigitalSetSimpleDictionary, DigitalOrStringConvertibleValue, TagStringValueDto } from '../../models';
import { ActualDataType, AggregationMode } from '../../models/enum';
import { IDigitalSetHelperService, IFormatNumberHelper, IStringValuesHelperService } from '.';
import { formatTimeStamp } from '../../common/helpers';

export interface IValueFormattingService {
    /**
     * Formats a numeric value to a string based on the data type and configuration.
     * @param val 
     * @param vm 
     * @param digitalSets 
     * @param aggregationMode 
     * @param decimals 
     * @param dateFormat
     * @param stringValues
     */
    formatValue(
        val: DigitalOrStringConvertibleValue,
        vm: IValueViewModel,
        digitalSets: DigitalSetSimpleDictionary,
        aggregationMode: AggregationMode,
        decimals: number,
        dateFormat? :string,
        stringValues?: TagStringValueDto[]
    ): string
}

export class ValueFormattingService implements IValueFormattingService {
    static serviceId = 'valueFormattingService';

    static $inject = [
        'digitalSetHelperService',
        'stringValuesHelperService',
        'formatNumberHelper'
    ];
    
    constructor(
        private _digitalSetHelperService: IDigitalSetHelperService,
        private _stringValuesHelperService: IStringValuesHelperService,
        private _formatNumberHelper: IFormatNumberHelper
    ) {
    }

    formatValue(
        val: DigitalOrStringConvertibleValue,
        vm: IValueViewModel,
        digitalSets: DigitalSetSimpleDictionary,
        aggregationMode: AggregationMode,
        decimals: number,
        dateFormat? :string,
        stringValues?: TagStringValueDto[]
    ): string {
        let formattedValue: string;
        switch (vm.actualDataType) {
            case ActualDataType.Float:
                formattedValue = this._formatNumberHelper.format(val.value, decimals);
                break;
            case ActualDataType.Digital:
                formattedValue = this.convertToDigital(val, vm, digitalSets, aggregationMode);
                break;
            case ActualDataType.Timestamp:
                formattedValue = formatTimeStamp(val.value, dateFormat);
                break;
            case ActualDataType.String:
                formattedValue = this.convertToString(val, vm, stringValues, aggregationMode);
                break;
        }
        return formattedValue;
    }

    private convertToDigital(
        val: DigitalOrStringConvertibleValue,
        vm: IValueViewModel,
        digitalSets: DigitalSetSimpleDictionary,
        aggregationMode: AggregationMode
    ): string {
        const convertible = val;
        let result = this._digitalSetHelperService.getValueOrDigital(vm, convertible, digitalSets, aggregationMode);
        if (!result || result === 'NaN') {
            result = '-';
        }
        return String(result);
    }

    private convertToString(
        val: DigitalOrStringConvertibleValue,
        vm: IValueViewModel,
        stringValues: TagStringValueDto[],
        aggregationMode: AggregationMode
    ): string {
        let result = this._stringValuesHelperService.getValueOrString(vm, val, stringValues, aggregationMode);
        if (!result || result === 'NaN') {
            result = '-';
        }
        return String(result);
    }
}